import { FC } from "react";
import { Center, Text } from "@chakra-ui/react";

export const DocumentsPageContentError: FC = () => {
  return (
    <Center flex="1">
      <Text variant="brand" pb="100px">
        Не удалось загрузить список документов
      </Text>
    </Center>
  );
};
